import { useState } from "react";

import { Grid, Typography, Button } from "@mui/material";

import { TextField } from "@aclymatepackages/atoms";

import dayjs from "dayjs";

import GrayPaper from "../atoms/GrayPaper";

import { useAuth, useCachedFirebaseCrud } from "../../helpers/firebase";
import { useUpdateVendorRelationshipFields } from "../../helpers/components/vendors";

// vendor-relationships (surfaced here under its "customers"/"vendor-relationships"
// aliases) no longer accepts direct client writes -- see firestore.rules and
// vendorRelationshipAuth.js. Every other collection this component is used
// for still goes through the generic cached CRUD hook.
const VENDOR_RELATIONSHIP_COLLECTIONS = ["customers", "vendor-relationships"];

const SavedNote = ({ text, createdAt, userName }) => (
  <Grid item>
    <GrayPaper>
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography variant="body2">{text}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="caption" color="textSecondary">
            {userName} - {dayjs(createdAt).format("MMM D, YYYY h:mm A")}
          </Typography>
        </Grid>
      </Grid>
    </GrayPaper>
  </Grid>
);

const TransactionNotes = ({ collection, docId, notes, editField, setListData }) => {
  const safeNotes = Array.isArray(notes) ? notes : [];
  const [noteText, setNoteText] = useState("");
  const [saving, setSaving] = useState(false);

  const [user] = useAuth();
  const { displayName } = user || {};
  const { updateCollectionDoc } = useCachedFirebaseCrud();
  const updateVendorRelationshipFields =
    useUpdateVendorRelationshipFields(collection);

  const saveNotes = (updatedNotes) =>
    VENDOR_RELATIONSHIP_COLLECTIONS.includes(collection)
      ? updateVendorRelationshipFields(docId, { notes: updatedNotes })
      : updateCollectionDoc(collection, docId, { notes: updatedNotes });

  const onAddNote = async () => {
    if (!noteText.trim()) {
      return;
    }

    setSaving(true);

    const newNote = {
      text: noteText.trim(),
      createdAt: new Date().toISOString(),
      userName: displayName || "Unknown User",
    };

    const updatedNotes = [...safeNotes, newNote];

    if (editField) {
      editField(updatedNotes);
    }

    if (setListData) {
      setListData((prevItems) =>
        prevItems.map((item) =>
          item.id === docId ? { ...item, notes: updatedNotes } : item
        )
      );
    }

    await saveNotes(updatedNotes);

    setNoteText("");
    setSaving(false);
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography variant="subtitle1">Notes</Typography>
      </Grid>
      {safeNotes.map(({ text, createdAt, userName }, idx) => (
        <SavedNote
          key={`note-${idx}`}
          text={text}
          createdAt={createdAt}
          userName={userName}
        />
      ))}
      <Grid item>
        <GrayPaper>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <TextField
                label="Add a note"
                value={noteText}
                setValue={setNoteText}
                multiline
                fullWidth
                minRows={3}
                disabled={saving}
              />
            </Grid>
            <Grid item container justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={onAddNote}
                  disabled={!noteText.trim() || saving}
                >
                  {saving ? "Saving..." : "Save Note"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </GrayPaper>
      </Grid>
    </Grid>
  );
};
export default TransactionNotes;
